module.exports = __webpack_public_path__ + "static/img/shebeileijiankongdian.7e55ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shebeileijiankongdian.png
// module id = sxPj
// module chunks = 4